import { Zap, ExternalLink } from 'lucide-react';

interface BlastBadgeProps {
  label: string;
  href?: string;
}

const BASE_CLASSES =
  'inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium ' +
  'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300';

export const BlastBadge = ({ label, href }: BlastBadgeProps) => {
  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className={`group/blast ${BASE_CLASSES} hover:bg-green-200 dark:hover:bg-green-900/50 transition-colors`}
      >
        <Zap className="h-3 w-3" />
        {label}
        <ExternalLink className="h-2.5 w-2.5 opacity-0 group-hover/blast:opacity-100 transition-opacity" />
      </a>
    );
  }
  return (
    <span className={BASE_CLASSES} title="One or more teams in this sport are linked to Blast.">
      <Zap className="h-3 w-3" />
      {label}
    </span>
  );
};
